import i18n from "@/src/i18n";
import * as z from "zod";

const LatestValuesDtoSchema = z
    .object({
        value: z.string().trim(),
        timestamp: z.number(),
        tendency: z.number().nullable(),
    })
    .readonly();

export const LatestDataDtoSchema = z
    .record(z.string(), z.record(z.string(), LatestValuesDtoSchema).readonly())
    .refine((latestData) => Object.values(latestData).length === 1, {
        error: () => i18n.t("validation:models.latestData.singleStation"),
    })
    .readonly();
export type LatestDataDto = z.output<typeof LatestDataDtoSchema>;
